// Who is acting vs who is approving, for the package guide's PIN prompts (Phase 1 shipping redesign, 2026-10-27).
//
// An IDENTITY prompt ("enter your PIN to ship / stage / confirm pickup") names the person doing the work. It must
// always ask (never fill in the admin session's PIN: an office PC left in an admin session used to record the admin
// as the operator) and may use the station's face sign-in. So it becomes {autofill: false, face: true}.
//
// An APPROVAL prompt (a manager override, palletActions.askInhouseOverride) passes {face: false}: the PIN AUTHORISES,
// a face token is refused there by the API, and the prompt is typed. It goes through exactly as the caller wrote it.
//
// Pure (no imports): features/salesOrders/pickupQueue.js and the Shipping hub reuse the same rule.

/** The options an identity prompt is shown with; an approval prompt's options unchanged. */
export function identityPinOptions(opts) {
  if (opts && opts.face === false) return opts;
  return { ...(opts || {}), autofill: false, face: true };
}

/** `ui` (features/desktopUi shape) whose pin() applies identityPinOptions. Everything else, including an optional
 *  `identity(why)`, is the base ui's own. */
export function identityUi(ui) {
  return {
    ...ui,
    pin: (message, opts) => ui.pin(message, identityPinOptions(opts)),
  };
}

export default identityUi;
